import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Translation from '../../lang/Translation';
import {getSiteCode} from '../../selectors/selectors';
import Spacing from '../../style-helper/Spacing';

const useStyles = createUseStyles({
  paymentSpecificEntity: {
    maxWidth: 960,
    margin: [0, 'auto'],
    textAlign: 'left',
    fontSize: 13,
    letterSpacing: 0.3,
    color: '#666',
    lineHeight: 1.5,
    paddingTop: Spacing.double,
  },
});

export function PaymentSpecificEntity(props) {
  const classes = useStyles(props);
  
  return (
    <div className={classes.paymentSpecificEntity} data-test="PaymentSpecificEntity">
      <Translation optionalExtension={props.siteCode}>newpay.legal.entity</Translation>
    </div>
  );
}

PaymentSpecificEntity.propTypes = {
  siteCode: PropTypes.string,
};

const mapStateToProps = state => ({
  siteCode: getSiteCode(state),
});

export default connect(mapStateToProps)(PaymentSpecificEntity);
